module.exports = __webpack_public_path__ + "img/CHN.b60682e.svg";